import styled from "styled-components";

const ListItem = styled.p.attrs({
  className: "font-semibold my-4",
})``;

const ListItemCard = styled.span.attrs({
  className: "mr-2 font-semibold",
})``;

const styles = {
  ListItem,
  ListItemCard,
};

export default styles;
